import { all } from 'redux-saga/effects';
import fileSaga from './file';
import userSaga from './user';
import calculationsSaga from './calculations';
import kreditdataSaga from './kreditdata';
import pensiongoalsSaga from './pensiongoals';
// import profileSaga from './profile'
// import flowSaga from './flow'

export default function* rootSaga() {
    yield all([
        fileSaga(),
        userSaga(),
        calculationsSaga(),
        kreditdataSaga(),
        pensiongoalsSaga(),
        // profileSaga(),
        // flowSaga()
    ]);
}
